import cls from 'classnames';
import './index.scss';

export const Skeleton = ({ className = '' }) => <div className={cls('skeleton', className)} />;